module.exports = __webpack_public_path__ + "static/media/happy.17b3799c.png";